import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCategoryBook';
/** Renders an SVG icon. */
const SvgCategoryBook = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.385 14.503a.75.75 0 0 1-.064 1.059L13.13 17.5l2.19 1.939a.75.75 0 0 1-.995 1.122l-2.823-2.5a.75.75 0 0 1 0-1.122l2.823-2.5a.75.75 0 0 1 1.06.064m2.585.967a.75.75 0 0 1 1.06 0l1.5 1.5a.75.75 0 0 1 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l.97-.97-.97-.97a.75.75 0 0 1 0-1.06"
      />
      <path
        fill="currentColor"
        d="m16.604 18.646.792-.792a.5.5 0 0 0 0-.708l-.792-.792a.5.5 0 0 0-.708 0l-.792.792a.5.5 0 0 0 0 .708l.792.792a.5.5 0 0 0 .708 0"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6 6.5A3.5 3.5 0 0 1 9.5 3H25a1 1 0 0 1 .7 1.716 3 3 0 0 0-.33.467c-.194.337-.37.79-.37 1.317s.176.98.368 1.316a3 3 0 0 0 .345.483A1 1 0 0 1 26 9v19a1 1 0 0 1-1 1H9a3 3 0 0 1-3-3zm2 3.163V26a1 1 0 0 0 1 1h15V10H9.5c-.537 0-1.045-.12-1.5-.337M23.26 8H9.5a1.5 1.5 0 1 1 0-3h13.76A4.5 4.5 0 0 0 23 6.5c0 .565.11 1.07.26 1.5"
      />
    </svg>
  );
};
SvgCategoryBook.displayName = displayName;
export default SvgCategoryBook;
